import { authenticateToken, login } from '@appt-digital/frontend-api-lib-sheffmed'
import LocalStorageService from '../../../utils/localStorageService'

import { loginRequestPin, loginConfirmPin } from '../../../utils/auth'

const loginHandler = async (
  values,
  navigate,
  setAlert,
  setLoading,
  setUser,
  setOrganisations
) => {
  setLoading(true)

  // send the request to generate the token
  // store the secret in local storage
  // store the email in local storage


  const res = await loginRequestPin(values.username)
  if (res.name === 'AxiosError') {
    setAlert({
      open: true,
      severity: 'error',
      message: 'Error logging into portal user.',
      action: false,
    })
    setLoading(false)
    return
  }

  console.log("loginRequestPin res", res)
  // return 

  LocalStorageService.set('email', values.username)
  LocalStorageService.set('secret', res.secret)

  setLoading(false)

  window.location.href = '/authenticate'


  
}

const authenticate2fa = async (
  pin,
  token,
  navigate,
  setAlert,
  setLoading,
  setUser,
  setOrganisations
) => {

  const email = localStorage.getItem('email')
  const secret = localStorage.getItem('secret')

  const res = await loginConfirmPin(email, pin, secret)

  if (!res?.success) { 

    // LocalStorageService.clear()
    window.location.href = '/login'

    return setAlert({
      open: true,
      severity: 'error',
      message: 'Invalid pin, please try again or return to login.',
      action: false,
    })
  }

  console.log("res.role", res.role)

  if (res.role !== 'Admin') {
    // LocalStorageService.clear()
    // window.location.href = '/login'

    return setAlert({
      open: true,
      severity: 'error',
      message: 'Access denied. You do not have permission to access this portal.',
      action: false,
    })
  }

  localStorage.setItem('userId', res?.userId)
  localStorage.setItem('token', res?.token)
  navigate('/dashboard')
  setLoading(false)
}

export { loginHandler, authenticate2fa }
